module.exports = __webpack_public_path__ + "static/media/monica_gonzalez_c.35945c20.jpg";